import { render, staticRenderFns } from "./MultipleUsersReviewUpload.vue?vue&type=template&id=1dcc6c19&scoped=true"
import script from "./MultipleUsersReviewUpload.vue?vue&type=script&lang=js"
export * from "./MultipleUsersReviewUpload.vue?vue&type=script&lang=js"
import style0 from "./MultipleUsersReviewUpload.vue?vue&type=style&index=0&id=1dcc6c19&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dcc6c19",
  null
  
)

export default component.exports